import { createEffect, Actions, ofType } from '@ngrx/effects';
import { inject, Injectable } from '@angular/core';

import { UserActionType, GetAuthUserAction, GetAuthUserErrorAction, GetAuthUserActionDone,
   LogUsersClientErrorAction, LogUsersClientErrorActionDone } from './actions';
import { switchMap, map, withLatestFrom, catchError, tap } from 'rxjs/operators';

import { Store, select } from '@ngrx/store';


import { Observable, of } from 'rxjs';
import { AuthService, ClientLogService, CommonCheckService } from 'FoxxyLib';
import { IAuthUser, IClientError } from 'FoxxyInterfaces';
import { InitialUserState } from './state';


@Injectable()
export class UserEffects {

  state$ : Observable<any> = of(InitialUserState);
  actions = inject(Actions);
  constructor(
    private store: Store<any>,


   private settingservice: ClientLogService,
    private authService: AuthService,
    private lipocheck: CommonCheckService
  ) {

    this.state$ = this.store.select(state => state.user);
    this.state$.subscribe(f =>
    {
      console.debug("UserState: " + JSON.stringify(f));
  });
    // this.state$ = this.store.select(state => state?.userstate); // this.store.pipe(select(selectuserState));

   }


  getAuthUserEffect$ = createEffect(() => { return  this.actions.pipe(
    ofType<GetAuthUserAction>(UserActionType.GetAuthUserAction),
    withLatestFrom(this.state$),
    switchMap(([action]) =>
      this.authService.claims$.pipe(
        map(f => {
          const usermodel = <IAuthUser>{ name: f.name, id: f.sub, client_id: f.client_id, member_of: f.member_of, shortId: this.lipocheck.getShortUserid(f.sub) }
          return new GetAuthUserActionDone({ user: usermodel });
        })
      )
    ), catchError((error, caught) => {
            this.store.dispatch(new GetAuthUserErrorAction({ error: error }));
            return caught;
        })
  )})





  logClientUserErrorEffect$ = createEffect(() => { return  this.actions.pipe(
    ofType<LogUsersClientErrorAction>(UserActionType.LogUsersClientErrorAction),
    withLatestFrom(this.state$),
    switchMap(([action]) =>
      this.settingservice.logClientError(<IClientError>{
        error: this.lipocheck.stringify(action.payload.error.error),
        modul: action.payload.error.modul, userid: action.payload.error.userid
      }
      ).pipe(
        map(f => {
          return new LogUsersClientErrorActionDone({ error: action.payload.error });
        })
        , catchError(error => {
          console.debug("While Loggging getting Error: " + JSON.stringify(error));
          return of();
        }
        )
      )
    )
  )})



}



